var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"16f5abca5a7ebab4c166b82053c7982d5923ecb2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app@coordinape"]={id:"16f5abca5a7ebab4c166b82053c7982d5923ecb2"};
      